import React from "react";
import "./LoadingBar.css";

function EmptyPage({ message = "No Config Found" }) {
  return (
    <div className="loadingBar">
      <div className="loader_xr" style={{ display: "block" }}>
        {message && <h2>{message}</h2>}
      </div>
    </div>
  );
}

export default EmptyPage;
